module.exports = require("./ko-KR");